<template>
  <div>
    <v-select
      :label="label"
      :items="possibleGroupBys"
      item-text="text"
      item-value="value"
      dense
      chips
      multiple
      clearable
      :value="value"
      return-object
      @input="$emit('input', $event)"
    >

    </v-select>
    <draggable
      :value="value"
      @input="$emit('input', $event)"
      v-bind="{ animation: 100 }"
    >
      <v-chip
        v-for="(groupBy, i) in value"
        :key="i + '-group-by-yeah'"
        label
        outlined
        style="cursor: grab;"
        class="ml-1"
        small
      >
        {{ i + 1 }}. {{ possibleGroupBys.find(v => v.value == groupBy.value)?.text }}
        <v-icon
          class="ml-3"
          size="15"
          @click="$emit('input', value.filter(s => s.value != groupBy.value))"
        >mdi-close</v-icon>
      </v-chip>
    </draggable>
  </div>
</template>

<script>
import possibleColumns from '@/utils/report/mappings';
import draggable from 'vuedraggable';

export default {
  mixins: [possibleColumns],
  components: {
    draggable
  },
  props: ['value', 'showAggregates', 'label']
}
</script>